import React from 'react';
import { Link } from 'react-router-dom/cjs/react-router-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

const TabTwo = () => {
	return (
		<div>
			<div className="row">
				<div className="col-lg-12">
					<Tabs>
						<div className="row row--30 align-items-center">
							<div className="col-lg-5 tabs_padding">
								<img className="radius-small" src='./images/tab/image.png' style={{ width: '100%', }} alt="Corporate React Template" />
							</div>
							<div className="col-lg-7 mt_md--40 mt_sm--40 tabs_left_padding">
								<div className="rn-default-tab style-two">
									<div className="tab-button-panel">
										<TabList className="tab-button">
											<Tab>
												<div className="rn-tab-button">
													<button><p>Financial Services</p></button>
												</div>
											</Tab>
											<Tab>
												<div className="rn-tab-button">
													<button><p>Healthcare & Fitness</p></button>
												</div>
											</Tab>
											<Tab>
												<div className="rn-tab-button">
													<button><p>Ecommerce, Retail & B2B</p></button>
												</div>
											</Tab>
											<Tab>
												<div className="rn-tab-button">
													<button><p>Education & Training</p></button>
												</div>
											</Tab>
											<Tab>
												<div className="rn-tab-button">
													<button><p>Food & Restaurant</p></button>
												</div>
											</Tab>
										</TabList>
									</div>

									<div className="tab-content-panel">
										<TabPanel>
											<div className="rn-tab-content" style={{ height: '40rem' }}>
												<div className="inner">
													<p>YGS Web Solutions Pvt Ltd. caters to businesses of all sizes and across diverse industries, delivering tailored solutions to meet their specific needs. Whether you're a startup seeking a professional website or an established enterprise looking for a digital transformation, we have the experience and expertise to realize your goals.</p>
													<Link to={'/our-services/digital-marketing/seo/'}>LEARN MORE</Link>
												</div>
											</div>
										</TabPanel>

										<TabPanel>
											<div className="rn-tab-content" style={{ height: '40rem' }}>
												<div className="inner">
													<p>Let us be your partner in directing people to your care if you're in the business of taking care of them.</p>
													<Link to={'/our-services/enterprise-solutions/erp/'}>LEARN MORE</Link>
												</div>
											</div>
										</TabPanel>

										<TabPanel>
											<div className="rn-tab-content" style={{ height: '40rem' }}>
												<div className="inner">
													<p>By not fully utilizing online sales, you could be disregarding one of the most substantial potential market segments. Our expertise in ecommerce solutions can assist you in harnessing the untapped potential and reaping the benefits of online sales.</p>
													<Link to={'/our-services/mobile-app-solutions/mobile-app-development/'}>LEARN MORE</Link>
												</div>
											</div>
										</TabPanel>
										<TabPanel>
											<div className="rn-tab-content" style={{ height: '40rem' }}>
												<div className="inner">
													<p>Elevate your educational or training institute with our cutting-edge web design and marketing solutions. Be the best to attract the best.</p>
													<Link to={'/our-services/game-development/game-development/'}>LEARN MORE</Link>
												</div>
											</div>
										</TabPanel>
										<TabPanel>
											<div className="rn-tab-content" style={{ height: '40rem' }}>
												<div className="inner">
													<p>We specialize in developing digital solutions and marketing campaigns that captivate and cater to the restaurant sector, no matter the business size. Let us handle your digital needs, so you can concentrate on serving up success.</p>
													<Link to={'/our-services/web-development/full-stack-development-with-next-js/'}>LEARN MORE</Link>
												</div>
											</div>
										</TabPanel>
									</div>
								</div>
							</div>
						</div>
					</Tabs>
				</div>
			</div>
		</div>
	)
}

export default TabTwo
